// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { TABBAR_ITEM_TRANSITION } from '../../../constants/ui/tabbar';
import theme from '../../../styled-components/dark';

const SvgElement = styled.svg`
  ${({ $isActive }) =>
    $isActive
      ? css`
          --background-path-fill: ${theme.TabBar.Button.default.active.color};
          --background-border-path-stroke: transparent;
        `
      : css`
          --background-path-fill: transparent;
          --background-border-path-stroke: ${theme.TabBar.Button.default.passive.color};
        `}
`;

const sharedPathTransition = css`
  transition: none ${TABBAR_ITEM_TRANSITION}ms ease-in-out;
  transition-property: fill, stroke;
`;

const BackgroundPath = styled.path`
  ${sharedPathTransition}
  fill: var(--background-path-fill, transparent);
`;
const BackgroundBorderPath = styled.path`
  ${sharedPathTransition}
  fill: transparent;
  stroke: var(--background-border-path-stroke, transparent);
`;

type HomeIconSvgAsComponentProps = {
  isActive?: boolean;
  className?: string;
};

const HomeIconSvgAsComponent = ({ className, isActive = false }: HomeIconSvgAsComponentProps) => {
  return (
    <SvgElement className={className} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" $isActive={isActive}>
      <BackgroundPath d="M4.03457 11.4355C3.37747 12.0053 3 12.8322 3 13.702V23.9009C3 25.5577 4.34315 26.9009 6 26.9009H11V21C11 19.3431 12.3431 18 14 18H16C17.6569 18 19 19.3431 19 21V26.9009H24C25.6569 26.9009 27 25.5577 27 23.9009V13.702C27 12.8322 26.6225 12.0053 25.9654 11.4355L16.9654 3.63107C15.8376 2.65309 14.1624 2.65309 13.0346 3.63107L4.03457 11.4355Z" />
      <BackgroundBorderPath
        d="M4 13.702C4 13.1222 4.25165 12.5709 4.68972 12.191L13.6897 4.38657C14.4416 3.73459 15.5584 3.73459 16.3103 4.38657L25.3103 12.191C25.7484 12.5709 26 13.1222 26 13.702V23.9009C26 25.0054 25.1046 25.9009 24 25.9009H19V20C19 18.8954 18.1046 18 17 18H13C11.8954 18 11 18.8954 11 20V25.9009H6C4.89543 25.9009 4 25.0054 4 23.9009V13.702Z"
        strokeWidth="2"
      />
    </SvgElement>
  );
};

export default HomeIconSvgAsComponent;
